export default {
  base: window._data.current_location,
  current: 'NZ'
}